export interface IApplication {
    id: string;
    title: string;
    logo: string;
    introduce: string;
    screenshot: string;
    categoryCode: string;
    categoryName: string;
    examineState: number;
    shelfState: number;
    systemType: string;
    terminalType: string;
    secret: string;
    redirectUrl: string;
    dataPushUrl: string;
    dataPushExamineState: number;
    useUserType: string;
    useScene: string;
}

export interface IApplicationTable {
    page: number;
    limit: number;
    page_count: number;
    total_rows: number;
    rows: IApplication [];
}

export interface IFrontApplicationState {
    keyWord: string;
    shelfState: number;
    applications: IApplicationTable;
    application: IApplication;
    authSchool: IAuthSchool;
}

export enum SHELF_STATE {
    NOSHELF,
    ONSHELF,
    OFFSHELF
}

export enum DATAPUSH_STATE {
    NOEXAMINE,
    PASS,
    NOPASS
}

export interface ISchool {
    id: string;
    schoolId: string;
    schoolName: string;
    applyTime: string;
    examineState: number;
    examineTime: string;
}

export interface IAuthSchool {
    authType: number;
    keyWord: string;
    examineState: number;
    page: number;
    limit: number;
    page_count: number;
    total_rows: number;
    rows: ISchool [];
}